/* eslint-disable
    goodeggs/lodash-matches-shorthand,
    goodeggs/lodash-prefer-immutable-method,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'lodash';
import moment from 'moment-timezone';

export default ngInject(function() {
  this.datePickerOpen = false;

  this.day = moment()
    .add(1, 'day')
    .toDate();
  this.capacity = null;

  this.overrideDropoffDay = () => {
    if (!this.overrideEnabled()) {
      return;
    }
    const dropoffDay = moment(this.day).format('YYYY-MM-DD');
    const capacity = Number(this.capacity);

    let override = _.find(this.overrides, {dropoffDay});
    if (override != null) {
      override.capacity = capacity;
    }

    if (!override) {
      override = {
        dropoffDay,
        capacity,
      };

      return this.overrides.push(override);
    }
  };

  this.cancelOverride = (day) => _.remove(this.overrides, {dropoffDay: day});

  this.openDatePicker = function(e) {
    return (this.datePickerOpen = true);
  };

  this.formatDate = (date) => moment(date).format('dddd, LL');

  this.dateIsInFuture = (date) => moment(date).isAfter(new Date());

  this.overrideEnabled = function() {
    return this.dateIsInFuture(this.day) && this.capacity != null;
  };

  this.recentFilter = (override) =>
    moment(override.dropoffDay).isAfter(moment().subtract(2, 'weeks'));

  return this;
});
